import { Button } from '@mantine/core'
import Box from '../ui/Box'
import SKU from '../ui/SKU'
import Badge from '../ui/Badge'

import dayjs from 'dayjs'
import { sumBy } from 'lodash'

export default function ComponentValue({ component, openComponentEdit }) {
    return (
        <Box title="Informations" rightSection={<SKU component={component} />}>
            <div className="flex flex-col gap-3">
                <div className="flex flex-col">
                    <span className="text-sm text-gray-500">
                        Date d&apos;expédition
                    </span>

                    {component.dispatch_date && (
                        <span className="text-orange-500 font-medium">
                            {dayjs(component.dispatch_date).format('LL')}
                        </span>
                    )}

                    {!component.dispatch_date && (
                        <span className="text-green-500 font-medium">
                            Jour ouvré suivant
                        </span>
                    )}
                </div>

                <div>
                    <span className="text-sm text-gray-500">
                        Valeur d'inventaire
                    </span>

                    <div className="flex justify-between items-center font-medium">
                        {component.value && component.value_currency && (
                            <div className="flex gap-2">
                                <span>
                                    {new Intl.NumberFormat('fr', {
                                        style: 'currency',
                                        currency: component.value_currency,
                                    }).format(component.value)}
                                </span>
                            </div>
                        )}

                        {!component.value && !component.currency && (
                            <div className="font-medium">Pas de valeur</div>
                        )}
                    </div>
                </div>

                <div className="flex flex-col mt-2">
                    <span className="text-sm text-gray-500">
                        Cycle d'inventaire
                    </span>

                    <span className="font-medium">
                        {component.inventory_cycle_days
                            ? 'Tous les ' +
                              component.inventory_cycle_days +
                              ' jours'
                            : 'Inventaire non requis'}
                    </span>
                </div>

                <div className="flex flex-col mt-2 hidden">
                    <span className="font-medium text-sm">
                        Vendus sur le site en collection permanente
                    </span>

                    <span className="text-sm text-gray-500">
                        {component.is_permanently_sold ? 'Oui' : 'Non'}
                    </span>
                </div>

                <div className="flex flex-col mt-2">
                    <span className="text-sm text-gray-500">Collections</span>

                    <div className="flex flex-col gap-1 items-start mt-1">
                        {component.collections.map((collection) => (
                            <Badge color="gray" key={collection.id}>
                                {collection.name_fr}
                            </Badge>
                        ))}

                        {!component.collections.length && (
                            <span className="font-medium">Aucune associée</span>
                        )}
                    </div>
                </div>

                <Button
                    className="mt-5"
                    variant="light"
                    color="dark"
                    onClick={openComponentEdit}
                >
                    Modifier
                </Button>
            </div>
        </Box>
    )
}
